import { apiRequest, queryString } from "./http";
import type {
  BudgetSummary,
  MoneyValue,
  PaymentMutation,
  PaymentRecord,
} from "./generated/openapi";

export type { BudgetSummary, MoneyValue, PaymentRecord } from "./generated/openapi";

export const budgetApi = {
  getForProject: (projectId: string | number) =>
    apiRequest<BudgetSummary>(`/api/projects/${projectId}/budget`),

  updateForProject: (projectId: string | number, totalBudget: MoneyValue) =>
    apiRequest<BudgetSummary>(`/api/projects/${projectId}/budget`, {
      method: "PATCH",
      body: JSON.stringify({ total_budget: totalBudget }),
    }),

  listPayments: (
    projectId: string | number,
    params: import("./generated/openapi").ApiListParams = {},
  ) =>
    apiRequest<PaymentRecord[]>(
      `/api/projects/${projectId}/payments${queryString(params)}`,
    ),

  createPayment: (projectId: string | number, payload: PaymentMutation) =>
    apiRequest<PaymentRecord>(`/api/projects/${projectId}/payments`, {
      method: "POST",
      body: JSON.stringify(payload),
    }),

  updatePayment: (paymentId: string | number, payload: PaymentMutation) =>
    apiRequest<PaymentRecord>(`/api/budgets/payments/${paymentId}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
    }),

  deletePayment: (paymentId: string | number) =>
    apiRequest<PaymentRecord>(`/api/budgets/payments/${paymentId}`, {
      method: "DELETE",
    }),
};
